import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
  '& .MuiInputBase-root': {
    borderRadius: '8px',
  },
}));
